module.exports = __webpack_public_path__ + "static/media/upwork.b83756ba.svg";